(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ac-home-care"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ac-testimonial-slider')) {
    customElements.define('ac-testimonial-slider', class extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-dot]'));
        this.index = 0;
        this.delay = Number(this.dataset.delay) || 7000;
        this.querySelector('[data-previous]')?.addEventListener('click', () => this.show(this.index - 1));
        this.querySelector('[data-next]')?.addEventListener('click', () => this.show(this.index + 1));
        this.dots.forEach((dot) => dot.addEventListener('click', () => this.show(Number(dot.dataset.dot))));
        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.start());
        document.addEventListener('shopify:block:select', (event) => {
          const slide = event.target.closest('[data-slide]');
          if (slide && this.contains(slide)) {
            this.stop();
            this.show(Number(slide.dataset.slideIndex));
          }
        });
        this.start();
      }
      show(nextIndex) {
        if (!this.slides.length) return;
        this.index = (nextIndex + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, index) => {
          const active = index === this.index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        });
        this.dots.forEach((dot, index) => dot.classList.toggle('is-active', index === this.index));
        this.start();
      }
      start() {
        this.stop();
        if (this.slides.length > 1 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          this.timer = window.setInterval(() => this.show(this.index + 1), this.delay);
        }
      }
      stop() {
        if (this.timer) window.clearInterval(this.timer);
      }
      disconnectedCallback() {
        this.stop();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ac-video-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ac-buffered-video')) {
    class AcBufferedVideo extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;

        this.video = this.querySelector('video');
        if (!this.video) return;

        this.video.muted = true;
        this.video.playsInline = true;
        this.stallFallbackUsed = false;

        const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
        const downlink = connection && Number(connection.downlink);
        const saveData = connection && connection.saveData;
        const highSource = this.video.dataset.hdSrc;
        const mediumSource = this.video.dataset.mdSrc;
        const lowSource = this.video.dataset.lowSrc;

        let selectedSource = highSource;
        if (saveData && lowSource) {
          selectedSource = lowSource;
        } else if (downlink && downlink < 3.5 && lowSource) {
          selectedSource = lowSource;
        } else if (downlink && downlink < 6 && mediumSource) {
          selectedSource = mediumSource;
        }

        if (selectedSource) {
          this.video.src = selectedSource;
          this.video.dataset.activeSrc = selectedSource;
        }

        this.hasPlayableBuffer = () => {
          if (this.video.readyState < HTMLMediaElement.HAVE_FUTURE_DATA) return false;
          if (!this.video.duration || !this.video.buffered.length) return this.video.readyState >= HTMLMediaElement.HAVE_ENOUGH_DATA;

          const bufferedEnd = this.video.buffered.end(this.video.buffered.length - 1);
          return bufferedEnd - this.video.currentTime >= Math.min(6, this.video.duration * 0.45)
            || bufferedEnd >= this.video.duration - 0.25;
        };

        this.startPlayback = () => {
          if (document.hidden || !this.hasPlayableBuffer()) return;
          this.video.play().catch(() => {});
        };

        this.handleVisibility = () => {
          if (!document.hidden) this.startPlayback();
        };

        this.handleStall = () => {
          if (this.stallFallbackUsed || !mediumSource || this.video.dataset.activeSrc === mediumSource || this.video.dataset.activeSrc === lowSource) return;
          this.stallFallbackUsed = true;
          const resumeAt = this.video.currentTime;
          this.video.src = mediumSource;
          this.video.dataset.activeSrc = mediumSource;
          this.video.load();
          this.video.addEventListener('loadedmetadata', () => {
            this.video.currentTime = Math.min(resumeAt, Math.max(0, this.video.duration - 0.25));
          }, { once: true });
        };

        this.video.addEventListener('progress', this.startPlayback);
        this.video.addEventListener('canplaythrough', this.startPlayback);
        this.video.addEventListener('waiting', this.handleStall);
        this.video.addEventListener('stalled', this.handleStall);
        document.addEventListener('visibilitychange', this.handleVisibility);

        this.video.load();
        this.startPlayback();
      }

      disconnectedCallback() {
        if (!this.video) return;
        this.video.removeEventListener('progress', this.startPlayback);
        this.video.removeEventListener('canplaythrough', this.startPlayback);
        this.video.removeEventListener('waiting', this.handleStall);
        this.video.removeEventListener('stalled', this.handleStall);
        document.removeEventListener('visibilitychange', this.handleVisibility);
      }
    }

    customElements.define('ac-buffered-video', AcBufferedVideo);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
